import { render, staticRenderFns } from "./ResellerProductViewGlobal.vue?vue&type=template&id=2bbfce1a"
import script from "./ResellerProductViewGlobal.vue?vue&type=script&lang=js"
export * from "./ResellerProductViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports